import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { TableComponent } from "../table.component";
import { SelectionModel } from "@angular/cdk/collections";
import { Router } from "@angular/router";
import { SafrattiRequestService } from "src/services/safratti-request.service";
import { TravelerDetail } from "src/models/traveler-detail";
import { GTSService } from "src/services/gts.service";
import { IssuePolicyRequest } from "src/dto/request/issue-policy-request";
import { DataListRowResponse } from "src/models/data-list-row-response";
import { environment } from "src/environments/environment";
import { AccountResponse } from "src/models/account-response";
import { DataListRowRequest } from "src/models/data-list-row-request";
import { AuthRequest } from "src/dto/request/auth-request";
import { Helpers } from "src/helpers/helpers";
import * as amplitude from "@amplitude/analytics-browser";
import { Identify, identify } from "@amplitude/analytics-browser";
import { sessionReplayPlugin } from "@amplitude/plugin-session-replay-browser";
import { SendEmailRequest } from "src/dto/request/send-email-request";
import { UTMService } from "src/services/utm-service";
import { TransactionDetails } from "src/dto/request/transaction-details";
import { GoogleTagManagerService } from "angular-google-tag-manager";
import { UpdatePolicyRequest } from "src/dto/request/update-policy-request";
import { UTMParameters } from "src/models/utm-parameters";
import { firstValueFrom } from "rxjs";

declare global {
  interface Window {
    fbq: (
      event: string,
      action: string,
      details?: { currency: string; value: number },
      pixelId?: string,
    ) => void;
    snaptr: (
      event: string,
      action: string,
      details?: { currency: string; value: number },
    ) => void;
    ttq: (
      event: string,
      action: string,
      details?: { currency: string; value: number },
    ) => void;
  }
}

@Component({
  selector: "app-consumer-safratti-request",
  templateUrl: "./consumer-safratti-request.component.html",
  styleUrls: ["./consumer-safratti-request.component.css"],
})
export class ConsumerSafrattiRequestComponent extends TableComponent<Request> {
  pageTitle = "Request";
  requestsArray = [];
  error: any;
  displayedColumns: string[] = [
    "id",
    "customerName",
    "email",
    "phoneNumber",
    "policyType",
    "policyNumber",
    "requestType",
    "date",
    "status",
    "policyUpdateAction",
    "basePremium",
    "policyFee",
    "totalFee",
    "totalPremium",
    "convenienceFee",
    "netAmount",
    "discountAmount",
    "promotionName",
    "paymentReference",
    "refund",
    "collection",
    "source",
    "issuer",
  ];
  selection = new SelectionModel<any>(true, []);
  currentPlan?: DataListRowResponse;
  currentResidenceCountry?: DataListRowResponse;
  currentDuration?: DataListRowResponse;
  currentDestinationCountry?: DataListRowResponse;
  currentCoverageZone?: DataListRowResponse;
  relations: DataListRowResponse[] = [];
  countries: DataListRowResponse[] = [];
  plans: DataListRowResponse[] = [];
  durations: DataListRowResponse[] = [];
  coverageZones: DataListRowResponse[] = [];
  destinationCountries: DataListRowResponse[] = [];
  filteredDestinationCountries: DataListRowResponse[] = [];
  account?: AccountResponse;
  companyPrefix: string = "LSKW";
  companyCode: string = "5010";
  authRequest: AuthRequest = environment.authenticate;
  isZainPhoneNumber = false;

  constructor(
    private safrattiService: SafrattiRequestService,
    private _gtsService: GTSService,
    private _utmService: UTMService,
    private router: Router,
    private _helper: Helpers,
    private _gtmService: GoogleTagManagerService,
  ) {
    super(safrattiService);

    const sessionReplayTracking = sessionReplayPlugin({
      sampleRate: 1,
    });
    amplitude.add(sessionReplayTracking);
    amplitude.init("3155389f4e6e37e08805a1a47a47a4c4", undefined, {
      defaultTracking: {
        sessions: true,
        pageViews: true,
        formInteractions: true,
        fileDownloads: true,
      },
    });
  }

  openPurchaseDetail(userdata: TravelerDetail): void {
    if (userdata.status == "POLICY_ISSUED" || userdata.status == "ISSUED") {
      this.router.navigate(
        ["consumer-safratti-request/policy-status/" + userdata.id],
        { state: { policyIssuer: userdata.issuer } },
      );
    }
    if (userdata.status == "POLICY_MODIFIED") {
      this.router.navigate([
        "consumer-safratti-request/policy-detail/" + userdata.id,
      ]);
    }
  }

  formatIssueDate(val: any) {
    const [datePart, timePart] = val.split("T");

    const utcDate = new Date(`${datePart}T${timePart}Z`);

    const kuwaitOffset = 3 * 60 * 60 * 1000; // Kuwait is UTC+3 hours
    const kuwaitDate = new Date(utcDate.getTime() + kuwaitOffset);

    const hours = String(kuwaitDate.getUTCHours()).padStart(2, "0");
    const minutes = String(kuwaitDate.getUTCMinutes()).padStart(2, "0");
    const seconds = String(kuwaitDate.getUTCSeconds()).padStart(2, "0");
    const kuwaitTimeString = `${hours}:${minutes}:${seconds}`;

    const kuwaitDateFormatted = `${String(kuwaitDate.getUTCDate()).padStart(
      2,
      "0",
    )}/${String(kuwaitDate.getUTCMonth() + 1).padStart(
      2,
      "0",
    )}/${kuwaitDate.getUTCFullYear()}`;
    return `${kuwaitDateFormatted} ${kuwaitTimeString}`;
  }

  async onClickStatusButton(element: any, event: Event) {
    event.stopPropagation();

    const isZain = await this.isZainNumber(element.phoneNumber);
    const policyBody = {
      isZainPhonenumber: isZain,
      policyId: element.policyId,
    };
    if (element.status === "PAID") {
      this._gtsService.issuePolicy(policyBody).subscribe();
    } else {
      console.log("Hi")
      this._gtsService.sendPurchaseEmail(policyBody).subscribe();
    }
  }

  createUtmParameters(element: any) {
    const utmParameters = {
      clickId: element.clickId ?? "",
      utmCampaign: element.utmCampaign ?? "",
      utmContent: element.utmContent ?? "",
      utmTerm: element.utmTerm ?? "",
      utmMedium: element.utmMedium ?? "",
      utmSource: element.source ?? "",
    };
    return utmParameters;
  }

  trackPurchaseEvent(
    policyId: string,
    amountPaid: number,
    utmParameters: UTMParameters,
  ) {
    const clickid = utmParameters?.clickId;
    const utm_source = utmParameters?.utmSource;
    const utm_campaign = utmParameters?.utmCampaign;
    const utm_content = utmParameters?.utmContent;
    const utm_term = utmParameters?.utmTerm;
    const utm_medium = utmParameters?.utmMedium;
    this._gtmService.pushTag({
      event: "purchase",
      clickid,
      utm_source,
      utm_campaign,
      utm_content,
      utm_term,
      utm_medium,
      pageName: window.location.href,
      currency: "KWD",
      value: amountPaid,
      items: [
        {
          item_id: policyId,
          item_name: "Safratti Policy",
        },
      ],
    });

    if (utmParameters && utmParameters.utmTerm === "mobibox") {
      this._utmService.registerConversion(utmParameters).subscribe();
    }

    const purchaseEventDetail = {
      currency: "KWD",
      value: amountPaid,
    };
    // meta purchase event track
    if (typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "Purchase", purchaseEventDetail);
      window.fbq(
        "trackSingleCustom",
        "Purchase",
        purchaseEventDetail,
        "482608628049457",
      );
    }

    // For Snapchat
    if (typeof window !== "undefined" && typeof window.snaptr === "function") {
      window.snaptr("track", "PURCHASE", purchaseEventDetail);
    }

    // For TikTok
    if (typeof window !== "undefined" && typeof window.ttq === "function") {
      window.ttq("track", "CompletePayment", purchaseEventDetail);
    }
  }

  async isZainNumber(phoneNumber: string | number): Promise<boolean> {
    const response = await firstValueFrom(
      this._gtsService.zainPhoneNumberValidation({ phoneNumber }),
    );

    return response.isValid;
  }
}
